module.exports = __webpack_public_path__ + "static/media/YF42_2.eb45524a.jpg";